export default __webpack_public_path__ + "static/media/Group8887.ca08110b.svg";